module.exports = __webpack_public_path__ + "static/media/zocalo_cortina.bdb80a38.jpg";